// extracted by mini-css-extract-plugin
export default {"layout":"PageLayout_layout__39kjl","contentWrapper":"PageLayout_contentWrapper__hDbm0"};